import { adminApiClient, type AdminApiClient } from './client';

export interface AdminProfile {
  id: string;
  email: string;
  displayName: string;
  mustResetPw: boolean;
}

export interface LoginResponse {
  sessionToken: string;
  expiresAt: string;
  admin: AdminProfile;
}

export interface AuthApi {
  login: (input: { email: string; password: string }) => Promise<LoginResponse>;
  me: () => Promise<{ admin: AdminProfile }>;
  logout: () => Promise<{ success: boolean }>;
  changePassword: (input: {
    currentPassword: string;
    newPassword: string;
  }) => Promise<{ success: boolean }>;
}

export const createAuthApi = (client: AdminApiClient = adminApiClient): AuthApi => ({
  login: async (input) =>
    client.request<LoginResponse>('/admin/auth/login', {
      method: 'POST',
      body: input,
    }),
  me: async () => client.request<{ admin: AdminProfile }>('/admin/auth/me'),
  logout: async () =>
    client.request<{ success: boolean }>('/admin/auth/logout', { method: 'POST' }),
  changePassword: async (input) =>
    client.request<{ success: boolean }>('/admin/auth/change-password', {
      method: 'POST',
      body: input,
    }),
});

export const authApi = createAuthApi();
